import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    FlatList,
    TextInput
} from "react-native";

// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
let width = 0;
let height = 0;
let scale = 1;
let styles = {};
let isMobile = false;
const arrowUp = require("../images/Filters/arrowUp.png");
const emptySquare = require("../images/Filters/emptySquare.png");
const arrowDown = require("../images/chevronDown.png");
const filledSquare = require("../images/Filters/filledSquare.png");
const imgSearchIcon = require("../images/Shop/searchIcon.png");
const imgMic = require("../images/Shop/mic.png");
const imgCart = require("../images/Shop/cartIcon.png");
const closeIcon = require("../images/Commons/closeIcon.png");
let curLanguage = "";
let sectionWidth = 0;
class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            applied: false,
            filtersSelected: 0,
            showPharmaceuticalBrands: true,
            showConsumerBrands: true,
            showCategories: true,
            consumerBrands: [],
            brands: [],
            categories: [],
            fullConsumerBrands: [],
            fullBrands: [],
            fullCategories: [],
            products: [],
            filtersID: [],
            filterName: [],
            showOrderNow: false,
            pharmaFilters: [],
            categoryFilter: [],
            pharmaceuticalFilters: [],
            allFilters: [],
            productsLen: 0,
            checkedFilters: [],
        };
    }
    Pressables = {};

    async componentDidMount() {
        loaderHandler.showLoader(STRINGS.loading, this.props.self);
        curLanguage = STRINGS.curLanguage;
        this.loadData();
        loaderHandler.hideLoader();
    }

    loadData = async () => {
        const consumerChosenFilters = this.props.consumerChosenFilters || [];
        if (consumerChosenFilters.length > 0) {
            this.setState({
                consumerChosenFilters,
                // selectedFilter: consumerChosenFilters[0],
            });
        }
        const pharmaChosenFilter = this.props.pharmaChosenFilter || [];
        if (pharmaChosenFilter.length > 0) {
            this.setState({
                pharmaChosenFilter,
                // selectedFilter: consumerChosenFilters[0],
            });
        }
        const categChosenFilter = this.props.categChosenFilter || [];
        if (categChosenFilter.length > 0) {
            this.setState({
                categChosenFilter,
            });
        }

        const productsLen = this.props.productsLen;
        this.setState({ productsLen: productsLen });
        const checkedFilters = this.props.brands;
        if (checkedFilters) {
            this.setState({ checkedFilters });
        }
        const brandsResp = await ServerOperations.getPharmaceuticalsBrands();
        const consumerBrandsResp = await ServerOperations.getConumerBrands();
        const catgResp = await ServerOperations.getCategories();

        this.setState({
            brands: brandsResp,
            fullBrands: brandsResp,
            consumerBrands: consumerBrandsResp,
            fullConsumerBrands: consumerBrandsResp,
            categories: catgResp,
            fullCategories: catgResp,
            allFilters: this.props.allFilters || [],
            filterName: this.props.filtersNames || [],
            orgAllFilters: (this.props.allFilters || []).slice(),
            orgFilterName: (this.props.filtersNames || []).slice(),
        });

        this.loadProducts();
    }

    filtersDistribution = (filters = this.state.allFilters) => {
        const pharmaceuticalFilters = [];
        const categoryFilter = [];
        const consumerFilter = [];

        filters.forEach((filter) => {
            if (filter.startsWith('PH-')) {
                pharmaceuticalFilters.push(filter);
            } else if (filter.startsWith('CTG-')) {
                categoryFilter.push(filter);
            } else {
                consumerFilter.push(filter);
            }
        });
        return { consumerFilter, categoryFilter, pharmaceuticalFilters };
    }

    loadProducts = async (wait = true) => {
        if (this.loadProductsTimeout) {
            clearTimeout(this.loadProductsTimeout);
        }
        if (wait) {
            await new Promise((resolve) => {
                this.loadProductsTimeout = setTimeout(resolve, 1200);
            });
        }
        loaderHandler.showLoader(STRINGS.loading, this);
        const { consumerFilter, categoryFilter, pharmaceuticalFilters } = this.filtersDistribution();
        let productsResp = await ServerOperations.getProducts('', consumerFilter, categoryFilter, pharmaceuticalFilters);
        if (this.state.allFilters.length === 0) {
            this.setState({
                products: productsResp,
                productsLen: productsResp.length,
                brands: this.state.fullBrands,
                consumerBrands: this.state.fullConsumerBrands,
                categories: this.state.fullCategories,
            });
            loaderHandler.hideLoader();
            return;
        }

        const filteredBrands = [];
        const filteredBrandIDS = [];
        const filteredConsumerBrands = [];
        const filteredCategs = [];
        const filteredCategIDS = [];

        productsResp.map((product) => {
            const brand = product.BRAND;
            const categ = product.CATEG;
            if (brand && !filteredBrandIDS.includes(brand)) {
                filteredBrandIDS.push(brand);
            }
            if (categ && !filteredCategIDS.includes(categ)) {
                filteredCategIDS.push(categ);
            }

        });
        this.state.fullBrands.forEach((brand) => {
            if (filteredBrandIDS.includes(brand.ID)) {
                filteredBrands.push(brand);
            }
        });
        this.state.fullConsumerBrands.forEach((brand) => {
            if (filteredBrandIDS.includes(brand.ID)) {
                filteredConsumerBrands.push(brand);
            }
        });
        this.state.fullCategories.forEach((categ) => {
            if (filteredCategIDS.includes(categ.ID)) {
                filteredCategs.push(categ);
            }
        });

        this.setState({
            products: productsResp,
            productsLen: productsResp.length,
            brands: filteredBrands,
            consumerBrands: filteredConsumerBrands,
            categories: filteredCategs,

        });
        loaderHandler.hideLoader();
    }


    renderHeaderMobile = () => {

        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1, marginHorizontal: 10, backgroundColor: '#f0f0f0', borderRadius: 20, paddingHorizontal: 10, justifyContent: 'center' }}>
                    <Image source={imgSearchIcon} style={{ width: 20, height: 20, marginRight: 10, tintColor: Styles.appColor1 }} />
                    <TextInput
                        style={{ flex: 1, height: 40, fontSize: 16, color: Styles.appColor1 }}
                        placeholder="Search for products"
                        placeholderTextColor='rgba(59, 98, 127, 0.50)'
                    />
                    <TouchableOpacity>
                        <Image source={imgMic} style={{ width: 20, height: 20, tintColor: Styles.appColor1 }} />
                    </TouchableOpacity>
                </View>
                <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgCart} style={{ width: 19.2, height: 19.2, stroke: Styles.appColor3 }}></Image>
                </TouchableOpacity>
            </View>
        )
    }



    renderMobile() {
        scale = width / 420;
        const sectionCount = isMobile ? 2 : 3;
        sectionWidth = (width - 40 - (20 * sectionCount - 1)) / sectionCount;
        return (
            <View style={styles.container}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {/* {this.renderHeaderMobile()} */}
                {Commons.renderAppHeader('', this, '', '', '', '', '', '', '')}
                {this.renderTitle()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, paddingLeft: 5 }}>
                        {isMobile && Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.renderPart2Mobile()}
                        {this.renderPart3Mobile()}
                        {Styles.renderVSeparator(30)}
                        {/* {this.renderPart4Mobile()} */}
                        {/* {Commons.renderFooter({}, this)} */}
                    </View>
                </ScrollView>
                {this.renderPart4Mobile()}
                <View style={{ position: 'absolute', bottom: 10, right: 20 }}>
                </View>
            </View >
        );
    }

    render() {
        this.title = 'filters';
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        styles = this.styles();

        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            return this.renderMobile();
        }
        width = (Commons.getDesktopWidth());
        height = (Commons.getDesktopHeight());
        styles = this.styles();
        const sectionCount = isMobile ? 2 : 3;
        sectionWidth = (width - 40 - (20 * sectionCount - 1)) / sectionCount;
        return (
            <View style={[styles.container, { width, backgroundColor: AppStyles.desktopBackgroundColor }]}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {/* {this.renderHeaderMobile()} */}
                <View style={{ width: width - 30, paddingRight: 10 }}>
                    {Commons.renderAppHeader('', this, '', '', '', '', '', '', '')}
                </View>
                {this.renderTitle()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width: width - 40, paddingLeft: 5, height: height - 200 }}>
                        {Styles.renderVSeparator(0)}
                        <View style={{ flexDirection: 'row' }}>
                            {this.renderPart1Mobile()}
                            {this.renderPart3Mobile()}
                        </View>
                        {this.renderPart2Mobile()}
                        {Styles.renderVSeparator(30)}
                        {/* {this.renderPart4Mobile()} */}
                        {/* {Commons.renderFooter({}, this)} */}
                    </View>
                </ScrollView>
                {this.renderPart4()}
                <View style={{ position: 'absolute', bottom: 20, right: 20 }}>
                </View>
            </View >
        );
    }

    renderTitle = () => {
        return (
            <View style={{ paddingLeft: 16, paddingBottom: 16, paddingTop: 4 }}>
                <View style={{ justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row', width: width - (isMobile ? 30 : 66) }}>
                    <Text style={[AppStyles.filtersHeaderStyle]}>{STRINGS.filters}</Text>
                    {this.state.applied && (
                        <Text style={[AppStyles.appliedFiltersStyle]}>{this.state.filtersSelected} {STRINGS.Applied_Filters}</Text>
                    )}
                    <TouchableOpacity onPress={() => {
                        this.props.applyFilters(null, null, true);
                    }}
                        style={{ marginRight: isMobile ? 12 : 25 }}>
                        <Image source={closeIcon} style={{ width: 14, height: 14 }} />
                    </TouchableOpacity>
                </View>
            </View>
        )
    }


    pharmaSelectedBrands = () => {

    }


    renderPart1Mobile = () => {
        if (!this.state.brands || this.state.brands.length === 0)
            return null;
        var arrowType = arrowUp;
        if (this.state.showPharmaceuticalBrands) {
            arrowType = arrowDown;
        }
        return (
            <View style={{ marginHorizontal: 16 }}>
                <TouchableOpacity style={[{
                    justifyContent: 'space-between',
                    alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row',
                    marginTop: 24
                }, { width: isMobile ? width - 42 : undefined }]}
                    onPress={() => { this.setState({ showPharmaceuticalBrands: !this.state.showPharmaceuticalBrands }) }}>
                    <Text style={[AppStyles.filtersTitlesStyle]}>{STRINGS.pharmaceutical_Brands}</Text>
                    {isMobile && <Image style={{ width: 9.6, height: 4.8, tintColor: Styles.appColor1 }} source={arrowType} />}
                </TouchableOpacity>
                {this.state.showPharmaceuticalBrands && (
                    <Animatable.View
                        style={{ overflow: 'hidden', width: isMobile ? undefined : sectionWidth }}
                        duration={300}
                        animation={this.state.showPharmaceuticalBrands ? "slideInDown" : "slideOutUp"}
                        pointerEvents={this.state.showPharmaceuticalBrands ? "auto" : "none"}
                        useNativeDriver
                        isVisible={this.state.showPharmaceuticalBrands}
                    >
                        <FlatList
                            data={this.state.brands}
                            keyExtractor={(item, index) => item.id?.toString() || index.toString()}
                            renderItem={({ item, index }) => {
                                let isSelected = this.state.allFilters.includes(item.ID);
                                const brands = [...this.state.brands];
                                return (
                                    <View style={[{
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        marginTop: 10.7,
                                    }, isMobile && { width }]}>
                                        <TouchableOpacity
                                            style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}
                                            onPress={() => {
                                                this.onItemClick(item);
                                            }}
                                        >
                                            <Image style={{ width: 17, height: 17 }} source={isSelected ? filledSquare : emptySquare} />
                                            <Text style={[AppStyles.filtersNamesStyle]}>{item.ENNAME}</Text>
                                        </TouchableOpacity>
                                    </View>
                                );
                            }}
                            contentContainerStyle={{
                                paddingVertical: 8,
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                flexWrap: 'wrap'
                            }}
                            numColumns={1}
                        />
                    </Animatable.View>
                )}
            </View>
        )

    }



    renderPart2Mobile = () => {
        var arrowType = arrowUp;
        if (this.state.showConsumerBrands) {
            arrowType = arrowDown;
        }
        // const consumerBrandName = [];
        let selectedIds = '';
        return (
            <View style={{ marginHorizontal: 16 }}>
                <TouchableOpacity style={[{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row', marginTop: 24
                }, isMobile && { width: width - 42 }]}
                    onPress={() => { this.setState({ showConsumerBrands: !this.state.showConsumerBrands }) }}>
                    <Text style={[AppStyles.filtersTitlesStyle]}>{STRINGS.app_Brands}</Text>
                    {isMobile && <Image style={{ width: 9.6, height: 4.8, tintColor: Styles.appColor1 }} source={arrowType} />}
                </TouchableOpacity>
                {this.state.showConsumerBrands && (
                    <Animatable.View
                        style={{ overflow: 'hidden' }}
                        duration={300}
                        animation={this.state.showConsumerBrands ? "slideInDown" : "slideOutUp"}
                        pointerEvents={this.state.showConsumerBrands ? "auto" : "none"}
                        useNativeDriver
                        isVisible={this.state.showConsumerBrands}
                    >
                        <FlatList
                            data={this.state.consumerBrands}
                            keyExtractor={(item, index) => item.id?.toString() || index.toString()}
                            renderItem={({ item, index }) => {
                                if (this.state.selectedFilter && this.state.selectedFilter === item.ID) {
                                    item.selected = true;
                                    this.setState({
                                        consumerBrands: this.state.consumerBrands.map(b => ({ ...b, selected: b.ID === item.ID })),
                                        applied: true,
                                        filtersSelected: 1
                                    });
                                }
                                let isSelected = this.state.allFilters.includes(item.ID);
                                const consumerBrands = [...this.state.consumerBrands];

                                // if (this.state.checkedFilters.includes(item.ID)) {
                                //     isSelected = !item.selected;
                                // }
                                return (
                                    <View style={[{
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        marginTop: 10.7,
                                    }, { width: isMobile ? (width / 2) : sectionWidth + 30 }]}>
                                        <TouchableOpacity
                                            style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}
                                            onPress={() => {
                                                this.onItemClick(item);
                                            }}
                                        >
                                            <Image style={{ width: 17, height: 17 }} source={isSelected ? filledSquare : emptySquare} />
                                            <Text style={[AppStyles.filtersNamesStyle]}>{item.ENNAME}</Text>
                                        </TouchableOpacity>
                                    </View>
                                );
                            }}
                            contentContainerStyle={{
                                paddingVertical: 8,
                            }}
                            numColumns={2}
                        />
                    </Animatable.View>
                )}
            </View>
        )
    }

    onItemClick = (item) => {
        let allFilters = Array.isArray(this.state.allFilters) ? [...this.state.allFilters] : [];
        let filterName = Array.isArray(this.state.filterName) ? [...this.state.filterName] : [];
        let isSelected = allFilters.includes(item.ID);
        if (!isSelected) {
            allFilters.push(item.ID);
            filterName.push(item.ENNAME);
        } else {
            allFilters = allFilters.filter(id => id !== item.ID);
            filterName = filterName.filter(name => name !== item.ENNAME);
        }
        this.setState({
            allFilters,
            filterName
        });
        this.loadProducts();
    }

    renderPart3Mobile = () => {
        var arrowType = arrowUp;
        if (this.state.showCategories) {
            arrowType = arrowDown;
        }

        return (
            <View style={{ marginHorizontal: 16 }}>
                <TouchableOpacity style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row', width: width - 42, marginTop: 24
                }}
                    onPress={() => { this.setState({ showCategories: !this.state.showCategories }) }}>
                    <Text style={[AppStyles.filtersTitlesStyle]}>{STRINGS.appCategories}</Text>
                    <Image style={{ width: 9.6, height: 4.8, tintColor: Styles.appColor1 }} source={arrowType} />
                </TouchableOpacity>
                {this.state.showCategories && (
                    <Animatable.View
                        style={{ width: width - 20, overflow: 'hidden' }}
                        duration={300}
                        animation={this.state.showCategories ? "slideInDown" : "slideOutUp"}
                        pointerEvents={this.state.showCategories ? "auto" : "none"}
                        useNativeDriver
                        isVisible={this.state.showCategories}
                    >
                        <FlatList
                            data={this.state.categories}
                            keyExtractor={(item, index) => item.id?.toString() || index.toString()}
                            renderItem={({ item, index }) => {
                                let isSelected = this.state.allFilters.includes(item.ID);
                                const categories = [...this.state.categories];
                                // if (this.state.checkedFilters.includes(item.ID)) {
                                //     isSelected = !item.selected;
                                // }
                                return (
                                    <View style={{
                                        width: isMobile ? '100%' : sectionWidth,
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                        marginTop: 10.7,
                                    }}>
                                        <TouchableOpacity
                                            style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}
                                            onPress={() => {
                                                this.onItemClick(item);
                                            }}
                                        >
                                            <Image style={{ width: 17, height: 17 }} source={isSelected ? filledSquare : emptySquare} />
                                            <Text style={[AppStyles.filtersNamesStyle]}>{item.ENNAME}</Text>
                                        </TouchableOpacity>
                                    </View>
                                );
                            }}
                            contentContainerStyle={{
                                paddingVertical: 8,
                            }}
                            numColumns={1}
                        />
                    </Animatable.View>
                )}
            </View>
        )

    }

    clearFilters = () => {
        const brands = this.state.brands.map(b => ({ ...b, selected: false }));
        const consumerBrands = this.state.consumerBrands.map(b => ({ ...b, selected: false }));
        const categories = this.state.categories.map(c => ({ ...c, selected: false }));
        this.setState({
            brands,
            consumerBrands,
            categories,
            applied: false,
            filtersSelected: 0,
            filtersID: '',
            pharmaceuticalFilters: [],
            categoryFilter: [],
            allFilters: [],
            filterName: [],
            checkedFilters: [],
        });

        try {
            this.props.consumerChosenFilters.length = 0;
            this.props.pharmaChosenFilter.length = 0;
            this.props.categChosenFilter.length = 0;
            this.props.filtersNames.length = 0;
        } catch (err) {

        }

        this.loadProducts(false);
    }


    renderPart4Mobile = () => {
        return (
            <View style={{ marginHorizontal: 8, marginVertical: 20, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: width - 60, gap: 16 }}>
                <TouchableOpacity style={[AppStyles.primaryButtonStyle, { width: (width - 40) / 2, height: 50, backgroundColor: '#D7D7D7' }]}
                    onPress={() => {
                        this.clearFilters();
                    }}>
                    <Text style={AppStyles.AcitvateButtonTextStyles}>{STRINGS.clear_Filters}</Text>
                </TouchableOpacity>
                <TouchableOpacity style={[AppStyles.primaryButtonStyle, { width: (width - 40) / 2, height: 50 }]}
                    onPress={() => {
                        if (this.props.applyFilters)
                            this.props.applyFilters(this.state.allFilters, this.state.filterName);
                    }}
                >
                    <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.view_filters} {this.state.productsLen} {STRINGS.items_filters}</Text>
                </TouchableOpacity>
            </View>
        )
    }

    renderPart4 = () => {
        return (
            <View style={{
                marginHorizontal: 8, marginTop: 20, marginBottom: 20, flexDirection: 'row',
                alignItems: 'center', justifyContent: 'space-between', width: width - 80, gap: 16
            }}>
                <TouchableOpacity style={[{ gap: 10, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }]}
                    onPress={() => {
                        this.clearFilters();
                    }}>
                    <Image source={closeIcon} style={{ width: 11, height: 11, tintColor: '#FF0000' }} />
                    <Text style={{ fontSize: 16, color: '#FF0000', fontFamily: AppStyles.fontFamily, fontWeight: '500' }}>{STRINGS.clear_Filters}</Text>
                </TouchableOpacity>
                <TouchableOpacity style={{
                    backgroundColor: AppStyles.appColor1, color: '#FFF', width: 150, paddingVertical: 16, gap: 8,
                    borderRadius: 6, justifyContent: 'center', alignItems: 'center', flexDirection: 'row'
                }}
                    onPress={() => {
                        if (this.props.applyFilters)
                            this.props.applyFilters(this.state.allFilters, this.state.filterName);
                    }}
                >
                    <Text style={{ fontSize: 16, color: '#fff', fontFamily: AppStyles.fontFamily, fontWeight: '500' }}>{STRINGS.apply_filters}</Text>
                </TouchableOpacity>
            </View>
        )
    }

    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: AppStyles.desktopBackgroundColor,
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default Filters;
